import React from "react";
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SpendDashboard from "./components/Rapid_Insights/SpendDashboard";
import { MsalProvider } from "@azure/msal-react";
import ProtectedRoute from "./components/Rapid_Insights/SSO";
import SupplierProfile from "./components/Rapid_Insights/SupplierProfile";
import Personas from "./components/Rapid_Insights/Personas";
import { FileProvider } from "./components/Rapid_Insights/FileContext";
import { msalInstance } from "./msalConfig";

function App() {
  console.log("@".repeat(40));
  console.log("Fronend Version 5 : Magic Cube With Custom Domain Reflection");
  console.log("@".repeat(40));

  return (
    <MsalProvider instance={msalInstance}>
       <FileProvider>
       <Routes>
        {/* Other routes */}
        <Route
          exact
          path="/"
          element={
            <ProtectedRoute>
              {" "}
              <SpendDashboard />{" "}
            </ProtectedRoute>

            // <SpendDashboard />
          }
        />

<Route
          exact
          path="/personas"
          element={
            <ProtectedRoute>
              {" "}
              <Personas />{" "}
            </ProtectedRoute>

            // <SpendDashboard />
          }
        />

        <Route
          path="/supplierprofile/:supplierName"
          element={
            <div>
              <SupplierProfile />
            </div>
          }
        />
      </Routes>
      </FileProvider>
    </MsalProvider>
  );
}

export default App;
